const $ = jQuery.noConflict();

'use strict';
const loadMore = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.toggleExpend();
	},
	toggleExpend: function() {
		$('.js-slider-read-more').each(function(e, el) {
			$(el).on('click', function() {
				if(!$(el).hasClass('read-less')) {
					const parentElement = $(this).parents('.js-testimonial-slider-parent');
					const innerText = parentElement.find('.js-inner-text');
					const fullText = parentElement.find('.js-text-content').attr('data-FullText');

					parentElement.find('.js-text-content p .js-more-inner').text(fullText);
					parentElement.find('.js-slider-read-more').text('Read Less').addClass('read-less');
					innerText.addClass('hide');
				} else {
					const parentElement = $(this).parents('.js-testimonial-slider-parent');
					const innerText = parentElement.find('.js-inner-text');
					const fullText = parentElement.find('.js-text-content').attr('data-ShortText');

					parentElement.find('.js-text-content p .js-more-inner').text(fullText);
					parentElement.find('.js-slider-read-more').text('Read More').removeClass('read-less');
					innerText.removeClass('hide');
				}
			});
		});
	},
};

export default loadMore;
